import React, { useContext } from "react";
import DetailPage from "../../../Components/navigation/detailPage";
import { TicketProps } from "../FlightLegs/ticketFlightLegs";
import { GlobalContext } from "../../../Utils/Contexts";
import MultilineEditor from "../../../Components/inputs/multilineEditor";
import { saveTicketChanges } from "../../../Utils/TicketDatabase";

export function TicketNotes(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);
    return (
        <DetailPage>
            <MultilineEditor
                sourceId={props.ticket.id}
                sourceProperty="comments"
                labelText="NOTES"
                isRequired={false}
                initialValue={props.ticket.comments}
                mergeChanges={(ticketId, values) => {
                    saveTicketChanges(ticketId, values).catch(() => props.showForceReloadDialogue());
                }}
                isDisabled={props.isReadOnly}
                errors={props.errors}
                containerUrl={"ticket/notes"}
                minRows={16}
            />
        </DetailPage>
    );
}
